// extracted by mini-css-extract-plugin
export var buttonContainer = "_79-1";
export var fontSizeSelect = "_79-3";
export var formatSelect = "_79-2";
export var formats = "_79-4";
export var hidden = "_79-5";
export var icon = "_79-6";
export var select = "_79-0";